import { purify } from '@vfit/shared/themes';
import { IUseFrameEditorialInput } from './frameEditorialInput.models';

export const useFrameEditorialInput = ({ description = '' }: IUseFrameEditorialInput) => {
  const [pDescription] = purify([description]);

  return { pDescription };
};

